// extracted by mini-css-extract-plugin
module.exports = {"hideOnDesktop":"styles_hideOnDesktop__3Plfk","hideOnTablet":"styles_hideOnTablet__zY07C","hideOnMobile":"styles_hideOnMobile__9cuAI","priceColumn":"styles_priceColumn__2J-YJ"};